import { Box } from "@material-ui/core";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";

type Props = {
  growth?: number;
  isGrowing?: boolean;
  isReverse?: boolean;
};

const GrowthIndicator = ({
  growth,
  isGrowing = false,
  isReverse = false,
}: Props) => {

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
        width: 56,
      }}
    >
      <Box style={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {isGrowing ? (
          !isReverse ? (
            <TrendingUpIcon style={{ color: "#3b82f6", width: 16, height: 16 }} />
          ) : (
            <TrendingUpIcon style={{ color: "#ef4444", width: 16, height: 16 }} />
          )
        ) : !isReverse ? (
          <TrendingDownIcon style={{ color: "#ef4444", width: 16, height: 16 }} />
        ) : (
          <TrendingDownIcon style={{ color: "#3b82f6", width: 16, height: 16 }} />
        )}
      </Box>
      <Box
        component="span"
        style={{
          fontSize: "0.75rem",
          flexShrink: 0,
          display: "inline-block",
        }}
      >
        {growth}%
      </Box>
    </Box>
  );
};

export default GrowthIndicator;
